import React, {useMemo, useRef, useState} from 'react';
import {Tag} from 'antd';
import dayjs from 'dayjs';
import TablePage from '../../pages/tablePage/TablePage';
import PushCampaignEditModal from './PushCampaignEditModal';
import {CONDITION_REGISTRY} from './conditions/ConditionPanel';

const PushCampaign = () => {
    const [rowData, setRowData] = useState({});
    const refreshRef = useRef(null);

    const columns = useMemo(() => ([
        {
            title: 'No.',
            dataIndex: 'id',
            width: 80,
            sorter: true,
        },
        {
            title: '제목',
            dataIndex: 'title',
            width: 300,
            search: true,
        },
        {
            title: '내용',
            dataIndex: 'body',
            width: 300,
        },
        {
            title: '발송 조건',
            dataIndex: 'conditions',
            width: 200,
            render: (conditions) => {
                const list = typeof conditions === 'string' ? JSON.parse(conditions) : (conditions || []);
                if (list.length === 0) return <Tag color="green">전체</Tag>;
                return list.map(c => (
                    <Tag key={c.type} color="blue">
                        {CONDITION_REGISTRY[c.type]?.label ?? c.type}
                    </Tag>
                ));
            },
        },
        {
            title: '발송 시각',
            dataIndex: 'scheduledAt',
            width: 160,
            render: (t) => dayjs.unix(t).format('YYYY-MM-DD HH:mm'),
            sorter: true,
        },
        {
            title: '상태',
            dataIndex: 'batchState',
            width: 100,
            render: (state) => {
                const map = {
                    reserved:  {color: 'cyan',      label: '발송 대기'},
                    sending:   {color: 'blue',       label: '발송 중'},
                    completed: {color: 'lightgray',  label: '발송 완료'},
                    canceled:  {color: 'red',        label: '취소'},
                };
                const {color, label} = map[state] ?? {color: 'default', label: state ?? '-'};
                return <Tag color={color}>{label}</Tag>;
            },
            filters: [
                {text: '발송 대기', value: 'reserved'},
                {text: '발송 중',   value: 'sending'},
                {text: '발송 완료', value: 'completed'},
                {text: '취소',      value: 'canceled'},
            ],
        },
    ]), []);

    return (
        <TablePage
            columns={columns}
            rowData={rowData}
            setRowData={setRowData}
            refreshRef={refreshRef}
            modal={PushCampaignEditModal}
            url="push-campaign"
            buttonText="신규 푸시 캠페인 추가"
        />
    );
};

export default PushCampaign;